$(function () {
    //variables
    const DEFAULT_WIDTH = 1200;
    const ANIMATION_DURATION = 500;
    const HEADER = $('.main-header');
    const BURGER_BUTTON = $('.main-header .burger__btn');
    const MAIN_MENU = $('.main-header .menu-list');
    const BLUR = $('.blur-content');
    const SEARCH_BUTTON = $('.main-header .search-icon');
    const SEARCH_BLOCK = $('.main-header .search-block');
    const SEARCH_INPUT = $('.main-header .search-form__input');
    const SEARCH_FORM = $('.main-header .search-form');
    const NAV_WRAP = $('.main-header .main-header__nav-wrap');
    const MENU = $('.main-header .main-header__menu');
    const ACCESSIBILITY = $('.block-accessibility');
    const BREAK_POINTS = {
        lg: {
            width: 1200,
            diff: 585
        },
        xlg: {
            width: 1440,
            diff: 690
        }
    };
    const isSafari = (function (agent) {
        switch (true) {
            case agent.indexOf("edge") > -1: return "MS Edge";
            case agent.indexOf("edg/") > -1: return "Edge ( chromium based)";
            case agent.indexOf("opr") > -1 && !!window.opr: return "Opera";
            case agent.indexOf("chrome") > -1 && !!window.chrome: return "Chrome";
            case agent.indexOf("trident") > -1: return "MS IE";
            case agent.indexOf("firefox") > -1: return "Mozilla Firefox";
            case agent.indexOf("safari") > -1: return "Safari";
            default: return "other";
        }
    })(window.navigator.userAgent.toLowerCase());
    let currWindowWidth = window.innerWidth;

    //calls
    countMenuItems();
    markHeaderAsScrolled();
    isSearchDisabled();

    //events
    BURGER_BUTTON.click(function (e) {
        toggleMenu();
    });

    MAIN_MENU.click(toggleCurrMenuItem());

    HEADER.on('mouseover', toggleBlur);

    HEADER.on('mouseout', toggleBlur);

    SEARCH_BUTTON.click(function () {
        toggleSearch();

        if (window.innerWidth < DEFAULT_WIDTH && isSearchDisabled()) SEARCH_FORM.submit();
    });

    SEARCH_INPUT.on('input', function () {
        inputValidation(this);
        isSearchDisabled();
    });

    SEARCH_INPUT.on('blur', () => {
        SEARCH_INPUT.removeClass('keyboard-focus');
    });

    $('.block-accessibility').on('accessibilityPreEvent', prepareHeaderToZoom());

    //global events
    $(window).scroll(function () {
        markHeaderAsScrolled();
        if (SEARCH_BLOCK.hasClass('active')) toggleSearch();
    });

    $(window).resize(function () {
        if (window.innerWidth !== currWindowWidth) {
            resizeMenu();
            if (SEARCH_BLOCK.hasClass('active')) {
                toggleSearch();
            }

            currWindowWidth = window.innerWidth;
        }
    });

    $(document).click(function (e) {
        if (SEARCH_BLOCK.hasClass('active') && !$(e.target).closest('.main-header__search').length) toggleSearch();
    });

    $('a[href="#contact-us"]').click(function() {
        if ($(body).hasClass('burger-open')) {
            $(body).removeClass('burger-open');
            $('.main-header__burger').removeClass('active');
            $('.burger__btn').removeClass('opened');
        }
    });
    $(document).on('tabNavEvent tabBlurEvent click', blurByTabNav);

    //functions
    function blurByTabNav(e) {
        if (e.type === 'click') {
            setTimeout(() => {
                const el = $(e.target).closest('.main-header li.menu-item');

                if (el.length && el.hasClass('clicked') && el.find('.sub-menu').length) BLUR.addClass('active');
            }, 20);
        }

        if (e.type === 'tabNavEvent') {
            const currEl = $(e.originalEvent.detail.nextEl).closest('.main-header li.menu-item');

            if (!currEl.length || (currEl.length && !currEl.hasClass('clicked'))) BLUR.removeClass('active');
        }

        if (e.type === 'tabBlurEvent') BLUR.removeClass('active');
    }

    function prepareHeaderToZoom() {
        let zoomEnd = 1;
        function zoomHeader (e) {
            const screenWidth = window.innerWidth;
            const { lg, xlg } = BREAK_POINTS;

            if (e && e.originalEvent.detail.scale === 1) {
                reset();
                return;
            }

            if (screenWidth >= DEFAULT_WIDTH && e) {
                setTimeout(function () {
                    const navWidth = HEADER.outerWidth();

                    if ((navWidth < lg.width ||
                        navWidth < xlg.width && screenWidth >= xlg.width) && HEADER.hasClass('responsive')) {
                        HEADER.removeClass('responsive');
                        HEADER.addClass('zoom');
                        ACCESSIBILITY.addClass('zoom');
                        if (zoomEnd === 1) zoomEnd = 2;
                    }

                    if ((navWidth >= lg.width && screenWidth < xlg.width) || (navWidth >= xlg.width && screenWidth >= xlg.width)) zoomEnd = 1;

                    if (zoomEnd === 1) {
                        HEADER.addClass('responsive');
                        HEADER.removeClass('zoom');
                        ACCESSIBILITY.removeClass('zoom');
                        BURGER_BUTTON.removeClass('opened');
                        BURGER_BUTTON.parent().removeClass('active');
                        $('body').removeClass('burger-open');
                    }

                    if (HEADER.hasClass('zoom') && isSafari !== 'Safari') {
                        MENU.css({ height: `calc(100vh * ${HEADER.outerWidth() / window.innerWidth} - 300px)`});
                    } else MENU.css({ height: ''});
                }, 10);
            }

            if (e && e.originalEvent.detail.scale > 1) {
                const actions = $('.main-header__contacts');
                const actionsTop = actions.get(0).getBoundingClientRect();

                if (actionsTop.y * e.originalEvent.detail.scale + 46 * e.originalEvent.detail.scale > window.innerHeight && isSafari !== 'Safari') {
                    MENU.css({ maxHeight: `calc(100vh * ${HEADER.outerWidth() / window.innerWidth} - 320px)`});
                } else if (!e.originalEvent.detail.scale) MENU.css({ maxHeight: ''});
            }
        }

        function reset() {
            zoomEnd = 1;
            HEADER.addClass('responsive');
            HEADER.removeClass('zoom');
            MENU.css({ height: ''});
            zoomHeader();
        }

        $(window).resize(() => {
            if (window.innerWidth !== currWindowWidth) {
                reset();

                currWindowWidth = window.innerWidth;
            }
        });

        return zoomHeader;
    }

    function toggleMenu() {
        let expanded = BURGER_BUTTON.attr('aria-expanded');
        BURGER_BUTTON.toggleClass('opened');

        BURGER_BUTTON.parent().toggleClass('active');
        $('body').toggleClass('burger-open');
        if ($('body').hasClass('burger-open')) {
            BURGER_BUTTON.attr('aria-expanded', 'true');
        } else {
            BURGER_BUTTON.attr('aria-expanded', 'false');
        }
        const settings = getAccessibilitySettingsFromStorage();

        if (settings.scale > 1 && isSafari !== 'Safari') {
            const actions = $('.main-header__contacts');
            const actionsTop = actions.get(0).getBoundingClientRect();

            if (actionsTop.y * settings.scale + 46 * settings.scale > window.innerHeight) {
                MENU.css({ maxHeight: `calc(100vh * ${HEADER.outerWidth() / window.innerWidth} - 320px)`});
            } else if (!settings.scale) MENU.css({ maxHeight: ''});
        }
    }

    function isSearchDisabled() {
        const val = SEARCH_INPUT.val();


        if (val) {
            SEARCH_BUTTON.removeClass('disabled');
        } else SEARCH_BUTTON.addClass('disabled');

        return !!val;
    }

    function toggleSearch () {
        SEARCH_BLOCK.toggleClass('active');
        HEADER.toggleClass('search-opened');
        if (window.innerWidth >= DEFAULT_WIDTH) {
            const parent = SEARCH_BLOCK.parent();

            if (SEARCH_BLOCK.hasClass('active')) {
                const width = NAV_WRAP.outerWidth();
                SEARCH_BLOCK.css({width: width, height: 40});
                parent.css({height: 40});
                if (SEARCH_BUTTON.hasClass('keyboard-focus')) {
                    setTimeout(() => {
                        SEARCH_INPUT.addClass('keyboard-focus');
                    }, 300);
                }
                SEARCH_INPUT.focus();
                SEARCH_INPUT.attr('tabindex', 0);
                $('.menu-list').addClass('not-active-menu');
            } else {
                SEARCH_BLOCK.css({width: ''});
                parent.css({height: ''});
                SEARCH_INPUT.attr('tabindex', -1);
                $('.menu-list').removeClass('not-active-menu');
            }
        }
    }

    function inputValidation(context) {
        const maxlength = parseInt($(context).attr('maxlength'));
        const length = $(context).val().length;

        length === maxlength ? SEARCH_INPUT.addClass('error') : SEARCH_INPUT.removeClass('error');
    }

    function resizeMenu() {
        if (BURGER_BUTTON.hasClass('opened')) {
            BURGER_BUTTON.removeClass('opened').parent().removeClass('active');
            $('.main-header .sub-menu').css({height: '', marginTop: ''}).removeClass('active');
            $('.main-header .menu-item').removeClass('opened');
            $('body').removeClass('burger-open');
        }
    }

    function toggleBlur(e) {
        if (window.innerWidth >= DEFAULT_WIDTH && !HEADER.hasClass('search-opened')) {
            if (e.type === 'mouseover') {
                const menuItem = $(e.target);
                const subMenu = menuItem.closest('li.menu-item').find('.sub-menu');

                if (menuItem.closest('li.menu-item') && subMenu.length) BLUR.addClass('active');
            } else BLUR.removeClass('active');
        }
    }

    function markHeaderAsScrolled() {
        const position = $(window).scrollTop();
        const isScrolled = HEADER.hasClass('scrolled');

        if (position && !isScrolled) {
            HEADER.addClass('scrolled');
        } else if (!position && isScrolled) {
            HEADER.removeClass('scrolled');
        }
    }

    function toggleCurrMenuItem() {
        let prevItem = $(null);

        return (e) => {
            if ($(e.target).closest('a.menu-link').get(0) && (window.innerWidth < DEFAULT_WIDTH || !HEADER.hasClass('responsive'))) {
                const currItem = $(e.target).closest('li.menu-item');

                if (currItem.get(0)) {
                    const subMenu = currItem.find('.sub-menu');
                    const prevSubMenu = prevItem.find('.sub-menu');
                    const isActive = subMenu.hasClass('active');

                    currItem.toggleClass('opened');

                    if (prevItem && prevItem.get(0) !== currItem.get(0)) {
                        prevSubMenu.parent().removeClass('opened');
                        prevSubMenu.animate({height: 0, marginTop: 0}, ANIMATION_DURATION, () => prevSubMenu.removeClass('active'));
                    }

                    subMenu.stop().animate({
                        height: !isActive ? currItem.find('.sub-menu-wrapper').outerHeight() : 0,
                        marginTop: !isActive ? 24 : 0

                    }, ANIMATION_DURATION, () => {
                        prevItem = currItem;
                        subMenu.toggleClass('active');
                    });
                }
            }
        }
    }

    function countMenuItems() {
        const DEFAULT_COLUMN_LENGTH = 8;
        const menu = $('.main-header .menu-list > li');

        menu.each(function () {
            const item = $(this);
            const menuItems = item.find('.sub-menu-list > li');
            const subMenuItems = item.find('.menu-item--sub-list > li');
            const totalAmount = menuItems.length + subMenuItems.length;
            const columns = Math.ceil(totalAmount / DEFAULT_COLUMN_LENGTH);
            item.addClass('columns-' + columns);

            let columnNumber = 1;
            let columnItemsCounter = 0;

            menuItems.each(function () {
                const length = $(this).find('.menu-item--sub-list > li').length + 1;
                columnItemsCounter += length;

                if (columnItemsCounter <= DEFAULT_COLUMN_LENGTH) {
                    if (columnItemsCounter === 4) $(this).addClass('fourth');
                    if (columnItemsCounter === 5) $(this).addClass('fives');
                } else {
                    columnNumber += 1;
                    columnItemsCounter = length;
                }
            });
        });
    }


    const menuWithChildrenAndHref = $('.menu-item-has-children[href]');

    function addDataAttributes() {
        menuWithChildrenAndHref.each(function () {
            const $this = $(this);
            const href = $(this).attr('href');

            if (href === '/industries/') {
                $(this).attr('data-mobile-name', 'All Industries');
            } else if (href === '/blog/') {
                $(this).attr('data-mobile-name', 'NIX Blog');
            }
        })
    }

    addDataAttributes();

    function updateMenuLinks() {
        if ($(window).width() <= 1200) {
            menuWithChildrenAndHref.each(function () {
                const $this = $(this);

                const href = $this.attr('href');
                const linkText = $this.attr('data-mobile-name') || $this.text().trim();

                $this.removeAttr('href');

                const submenuList = $this.closest('li.menu-item').find('.sub-menu-list');

                if (submenuList.length && !submenuList.find(`.menu-link--mobile`).length) {
                    const childListItem = $('<li>', {
                        class: 'menu-item--sub-list--item'
                    }).append(
                        $('<a>', {
                            class: 'menu-link--mobile',
                            href: href,
                            text: linkText
                        })
                    );

                   submenuList.prepend(childListItem);
                }
            });
        } else {
            menuWithChildrenAndHref.each(function () {
                const $this = $(this);

                const siblingLink = $this.closest('li.menu-item').find('.menu-link--mobile');
                const mobileListItem = $this.closest('li.menu-item').find('.menu-link--mobile').closest('li.menu-item--sub-list--item');

                if (siblingLink.length) {
                    const href = siblingLink.attr('href');
                    $this.attr('href', href);
                    mobileListItem.remove();
                }
            });
        }
    }

    updateMenuLinks();

    $(window).on('resize', updateMenuLinks);
});
